import type { AxiosInstance } from "axios";
import { addIgnoreLabel } from "../SiteAboutPageUtils/addIgnoreLabel";
import { IgnoreZone } from "../SiteAboutPageUtils/siteAboutInterfaces";
import { FlexCameraSummary } from "./types";

/**
 * Camera `ignore_zones/` POST rejects blank `stream_name` (DRF). Preset-zone / flex
 * templates may omit it — use a stable non-empty placeholder.
 */
export const ignoreZoneStreamNameForCameraApi = (
  zone: Pick<IgnoreZone, "stream_name" | "stream_id">
): string => {
  const raw = zone.stream_name;
  if (typeof raw === "string" && raw.trim() !== "") {
    return raw;
  }
  return `stream_${zone.stream_id}`;
};

/** Same objects as a normal ignore-zones POST, but every zone has an empty coordinates list. */
export const zonesWithEmptyCoordinates = (zones: IgnoreZone[]): IgnoreZone[] =>
  zones.map((zone) => ({
    ...zone,
    coordinates: [],
    stream_name: ignoreZoneStreamNameForCameraApi(zone),
  }));

export async function buildNoIgnoreZonesPostPayload(
  camera: FlexCameraSummary,
  defaultZonesFromContext: IgnoreZone[] | undefined,
  axiosInstance: AxiosInstance
): Promise<IgnoreZone[]> {
  let template: IgnoreZone[] = [];
  if (defaultZonesFromContext && defaultZonesFromContext.length > 0) {
    template = defaultZonesFromContext;
  } else {
    template = addIgnoreLabel(camera.ignore_zones || []);
  }
  if (template.length === 0) {
    const response = await axiosInstance.get(`/camera/${camera.id}/ignore_zones/`);
    template = addIgnoreLabel(response.data || []);
  }
  return zonesWithEmptyCoordinates(template);
}
